import {
  UseMutationOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { CREATE_KIT } from "../apiRoutes";

const mutateAddKit = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(CREATE_KIT, data);
};

const useAddKITMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: mutateAddKit,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({
        queryKey: ["kit"],
        exact: false,
      });
      queryParams?.onSuccess?.(data, variables, context);
    },
    ...queryParams,
  });
};

export default useAddKITMutation;
